import type { Href } from 'expo-router';

import { ROUTES } from '@/constants/routes';

/**
 * Which personal link the device holder shares from the icon action, Messages and Siri: an
 * expert's Ask Primum link, or an LMP's referral link.
 */
export type ShareLinkKind = 'expert' | 'referral';

/**
 * The words each native share surface shows for a role. The Messages and Siri extensions read
 * these from the app group, so editing them here ships by OTA; only the signed-out text and
 * Siri's action name stay compiled into the binary.
 */
export type ShareLinkLabels = {
  /** Heading in the Messages "+" app. */
  title: string;
  /** App-icon quick action. */
  actionTitle: string;
  /** What Siri and Shortcuts say when the action returns the link. */
  resultDialog: string;
};

export const SHARE_LINK_LABELS: Record<ShareLinkKind, ShareLinkLabels> = {
  expert: {
    title: 'Your Ask Primum link',
    actionTitle: 'Share my Ask Primum link',
    resultDialog: "Here's your Ask Primum link",
  },
  referral: {
    title: 'Your referral link',
    actionTitle: 'Share my referral link',
    resultDialog: "Here's your referral link",
  },
};

/**
 * Where a quick-action tap lands when the link cannot be shared straight away. The invites
 * screen reads `source` to attribute its funnel events, so the referral route carries it.
 */
export const SHARE_LINK_FALLBACK_ROUTE: Record<ShareLinkKind, Href> = {
  expert: ROUTES.ACCOUNT_QR_CODE,
  referral: `${ROUTES.ACCOUNT_INVITES}?source=quick_action` as Href,
};
